import React, { useState, useEffect } from "react";
import WorkflowCanvasEdit from "./Common Components/Workflow_CanvasEdit";
import WorkflowCanvasView from "./Common Components/Workflow_CanvasView";


const popupOverlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
};

const popupContentStyles = {
    position: "relative",
    width: "75vw",
    height: "75vh",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
};

const closeButtonStyles = {
    position: "absolute",
    top: "0px",
    right: "10px",
    fontSize: "2rem",
    background: "transparent",
    border: "none",
    cursor: "pointer", // ✅ ensures hand symbol on hover
    lineHeight: 1,
    padding: 0,
    userSelect: "none",
};

const PopupSubflowTemplate = ({ json, onClose, subflowTempName }) => {
    const [localJson] = useState(() => structuredClone(json));
    useEffect(() => {       
        reloadCanvas();
    }, []);
    const [reloadPopCounter, setReloadPopCounter] = useState(0);

    const reloadCanvas = () => {
        setReloadPopCounter(prev => prev + 1);
    };

    return (
        <div style={popupOverlayStyles}>
            <div style={popupContentStyles}>
                <p style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '18px', margin: 0 }}>
                    Subflow Template - {subflowTempName}
                </p>
                {/* Close button */}
                <button
                    onClick={onClose}
                    style={closeButtonStyles}
                    aria-label="Close popup"
                    type="button"
                >
                    ×
                </button>

                {/* Workflow Canvas */}
                <WorkflowCanvasView
                    key={`PopupView-${reloadPopCounter}`} // 🔹 correct unique key
                    json={localJson}
 
                />
       
            </div>
        </div>
    );
};

export default PopupSubflowTemplate;
